import { getDisasterSettingByArea, postMutiDisasterSetting} from '../../../api/eastCoastMonitorApi/disasterSettingApi'
import Utils from '../../../utils/utils'

const state = {
  allScenicAreaDisaster: [] //[{id: 1, disaster: []}, {id: 2, disaster: []}]
}

const getters = {
  getDisasterSettingByArea: (state) => (id) =>{
    return state.allScenicAreaDisaster.find(d => d.id === id)
  }
}

const actions = {
  async getDisasterSettingByArea({commit}, condition = {}) {
    const result = await getDisasterSettingByArea(condition)
    if(result.success) {
      commit('getDisaster', {id: condition.id, disaster: result.data})  
    }
    
  },
   
}

const mutations = {
  getDisaster: (state, data) => {
    let targetIndex  = state.allScenicAreaDisaster.findIndex(d => d.id === data.id)
    if (targetIndex === -1) {
      state.allScenicAreaDisaster.push(data)
    } else {
      // state.allScenicAreaDisaster[targetIndex] = data;
      state.allScenicAreaDisaster.splice(targetIndex, 1, data); 
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}